import entrypoint from "../../entrypoint";
import { TenantContent } from "../TenantContent";
import Landing from "./Landing";

export const content: TenantContent = { Landing };

entrypoint("dira", content);
